import { adalApiFetch } from "security/security";
import { loaderStatus } from "shared/loader/loader";

export async function getAsync(url: string) {
  try {
    loaderStatus.next(true);
    const reply = await adalApiFetch(url);

    if (!reply.ok) {
      throw reply;
    }

    return reply;
  } catch (error) {
    handleError(error);
    throw error;
  } finally {
    loaderStatus.next(false);
  }
}

export async function postAsync(
  url: string,
  payload: any,
  method: "POST" | "PUT" | "DELETE" = "POST"
) {
  try {
    loaderStatus.next(true);

    const reply = await adalApiFetch(url, {
      method,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!reply.ok) {
      throw reply;
    }

    return reply;
  } catch (error) {
    handleError(error);
    throw error;
  } finally {
    loaderStatus.next(false);
  }
}

export async function postFormAsync(
  url: string,
  formData: FormData,
  method: "POST" | "PUT" | "DELETE" = "POST"
) {
  try {
    loaderStatus.next(true);

    const reply = await adalApiFetch(url, {
      method,
      body: formData
    });

    if (!reply.ok) {
      throw reply;
    }

    return reply;
  } catch (error) {
    handleError(error);
    throw error;
  } finally {
    loaderStatus.next(false);
  }
}

function handleError(error: any) {
  console.error(error);
  if (error.status === undefined) {
    alert("Your session has expired. Don't worry, simply open another tab, login again, and then come back here.");
  } else {
    alert(`Network error: ${error.status} ${error.statusText}`);
  }
}



// WEBPACK FOOTER //
// ./src/utils/net.ts